export const userSignUpConstants = {
  USER_SIGNUP_REQUEST: 'USER_SIGNUP_REQUEST',
  USER_SIGNUP_SUCCESS: 'USER_SIGNUP_SUCCESS',
  USER_SIGNUP_FAILURE: 'USER_SIGNUP_FAILURE',
  DEFAULTERR: 'Something went wrong, please try again later',
};
